import { BASE_JWT_URL } from 'constants/environmentVariables';
import axiosInstance from 'services/axiosConfig';
import { handleErrors } from 'actions/errors';
import {
	createSubmitEvent,
	logEvent,
	updateSubmitEvent,
	deleteEvent
} from 'services/firebaseLogger';
import { setManageDrawer } from 'reducers/manageTablesSlice';
import { addSnackbarAlerts } from 'reducers/globalSlice';
import { currentAccountIdSelector } from 'reducers/userAuthSlice';
import { t } from 'i18next';

export const createInvite = payload => async (dispatch, getState) => {
	const currentAccountId = currentAccountIdSelector(getState());
	const url = `${BASE_JWT_URL}/account/${currentAccountId}/invite`;
	try {
		const response = await axiosInstance.post(url, payload);
		logEvent(createSubmitEvent('invite'));
		return response;
	} catch (error) {
		handleErrors({ errors: error, dispatch });
	}
};

export const updateInvite = (hash, payload) => async (dispatch, getState) => {
	const currentAccountId = currentAccountIdSelector(getState());
	const url = `${BASE_JWT_URL}/account/${currentAccountId}/invite/${hash}`;
	try {
		const response = await axiosInstance.put(url, payload);
		dispatch(
			setManageDrawer({
				data: response.data.data
			})
		);
		logEvent(updateSubmitEvent('invite'));
		return response;
	} catch (error) {
		handleErrors({ errors: error, dispatch });
	}
};

export const resendInvite = id => async (dispatch, getState) => {
	const currentAccountId = currentAccountIdSelector(getState());
	const url = `${BASE_JWT_URL}/account/${currentAccountId}/invite/${id}/resend`;
	try {
		const response = await axiosInstance.post(url);
		return response;
	} catch (error) {
		handleErrors({ errors: error, dispatch });
	}
};

export const deleteInvite = id => async (dispatch, getState) => {
	const currentAccountId = currentAccountIdSelector(getState());
	const url = `${BASE_JWT_URL}/account/${currentAccountId}/invite/${id}`;
	try {
		const response = await axiosInstance.delete(url);
		logEvent(deleteEvent('invite'));
		return response;
	} catch (error) {
		handleErrors({ errors: error, dispatch });
	}
};

export const redeemCheck = hash => async dispatch => {
	const url = `${BASE_JWT_URL}/invite/${hash}/redeemcheck`;
	try {
		const response = await axiosInstance.get(url);
		return response;
	} catch (error) {
		handleErrors({ errors: error, dispatch });
		return error.response.data.errors[0];
	}
};

export const redeemInviteWithUser = (hash, payload) => async dispatch => {
	const url = `${BASE_JWT_URL}/invite/${hash}/redeemwithuser`;
	try {
		const response = await axiosInstance.post(url, payload);
		dispatch(
			addSnackbarAlerts([
				{
					type: 'success',
					message: `${t('Password created')}. ${t('You may now sign in')}.`
				}
			])
		);
		return response;
	} catch (error) {
		handleErrors({ errors: error, dispatch });
	}
};

export const redeemInviteWithoutUser = (hash, payload) => async dispatch => {
	const url = `${BASE_JWT_URL}/invite/${hash}/redeem`;
	try {
		const response = await axiosInstance.post(url, payload);
		dispatch(
			addSnackbarAlerts([
				{
					type: 'success',
					message: `${t('Password created')}. ${t('You may now sign in')}.`
				}
			])
		);
		return response;
	} catch (error) {
		handleErrors({ errors: error, dispatch });
	}
};

export const fetchInviteDetails = id => async (dispatch, getState) => {
	const drawerState = getState().manageTables.manageDrawer;
	const currentAccountId = currentAccountIdSelector(getState());
	const url = `${BASE_JWT_URL}/account/${currentAccountId}/invite/${id}`;
	try {
		const response = await axiosInstance.get(url);
		dispatch(
			setManageDrawer({
				...drawerState,
				data: response.data.data
			})
		);
		return response;
	} catch (error) {
		handleErrors({ errors: error, dispatch });
	}
};
